
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuLittleRimaHumburgerSteakImage } from "@src/constants/images";
import { meta as ryunokoPageMeta } from "./ryunoko.mdx";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as afuriPageMeta } from "./afuri.mdx";
export const meta = {
  path: "/media/harajuku/little_rima",
  title: "【極上神戸牛】原宿のハンバーグの名店「リトルリマ」でランチをしよう！",
  description: "原宿でハンバーグのランチが食べたいなら、間違いなく「リトルリマ」一択だと思います。原宿にはハンバーグのお店が少ない中、リトルリマでは100％の神戸牛を使ったランチが堪能できます。店内の様子、ハンバーグのこだわりと、副菜まで「リトルリマ」でランチを食べる際に必要になる情報をご紹介させていただきます。",
  topImg: harajukuLittleRimaHumburgerSteakImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "ハンバーグ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でハンバーグのランチが食べたいなら、100％の神戸牛を使った極上のハンバーグランチが食べられるリトルリマがオススメです！`}</p>
    <p>{`原宿にはハンバーグを食べられるお店が少ない中、多くの有名人が訪れたり、メディアに取り上げられたりする名店です。`}</p>
    <p>{`店内の様子、ハンバーグのこだわりと、副菜まで「リトルリマ」でランチを食べる際に必要になる情報をご紹介させていただきます。`}</p>
    <h2>{`リトルリマとは？`}</h2>
    <InstaImage postId="BePbqwcHj0c" mdxType="InstaImage" />
    <p>{`原宿から青山方面に向かった先に位置するハンバーグの名店「リトルリマ」。原宿から表参道方面に向かったビルの地下に位置する知る人ぞ知る隠れ家的なお店。100％の神戸牛が食べられることで有名なリトルリマは、多くの有名人が訪れることもあり、ハンバーグ好きの方はリストに入れておきたい名店です。`}</p>
    <h3>{`昔ながらの趣のある店内`}</h3>
    <InstaImage postId="BntlJjYHLp2" mdxType="InstaImage" />
    <p>{`銀色に輝く鉄板は高級店の代名詞で、店内のレトロな雰囲気は落ち着いてランチが食べられる空間。鉄板の目の前にあるカウンター席と、テーブル席と併せて 17 席を完備しています。昔ながらの趣のあるお店で、どこか懐かしさを感じながら過ごすランチタイムは、普段とは違ったランチタイムを過ごすことができます。`}</p>
    <h2>{`ランチタイムがお得`}</h2>
    <InstaImage postId="Bq02kgJFvUL" mdxType="InstaImage" />
    <p>{`ディナータイムで訪れると、リトルリマでは客単価が 2 万円を超えるお店なので、気軽には中行きづらいお店です。
しかしランチタイムだと、単価千円〜二千円で神戸牛 100%のお肉を使ったハンバーグランチが食べられるので、ハンバーグをリトルリマで食べるならランチの時間帯に訪れるのがオススメ！`}</p>
    <h2>{`神戸牛 100％のハンバーグランチ`}</h2>
    <p>{`原宿で神戸牛のランチが食べられるお店は中々ないと思いますが、リトルリマではしっかり認定証がついた神戸牛ランチを堪能できます。
その内容について、一緒に見ていきましょう。`}</p>
    <h3>{`注文を受けてから作るハンバーグ`}</h3>
    <InstaImage postId="BszuJmkjTBX" mdxType="InstaImage" />
    <p>{`神戸牛 100％のハンバーグランチは、オーダーを聞いてから肉をこねて焼いてくれるので、出来上がりは驚くほどジューシーな味わい。写真を見ていただくとこの大きな牛肉の塊からハンバーグを作っていきます。`}</p>
    <h3>{`長年継ぎ足しのデミグラスソース`}</h3>
    <p>{`牛スジと野菜を 10 日間かけて煮込んで作るデミグラスソースは、驚くほど濃厚な香りと味わいです。
このデミグラスソースは、15 年以上継ぎ足しで作成しているそうで、1 日とて同じ味ではない日々進化し続けるソースが、ハンバーグの味を引き立たせてくれます。`}</p>
    <h3>{`ジューシーなハンバーグ`}</h3>
    <p>{`注文を受けてから作るハンバーグと、デミグラスソースが合わさって最終的に出来上がったハンバーグランチがこちら。`}</p>
    <InstaImage postId="BcOi73an6Lt" mdxType="InstaImage" />
    <InstaImage postId="BwTYRernZnW" mdxType="InstaImage" />
    <p>{`噛んでも噛んでもずっとジューシーな味わいのハンバーグですが、その`}<strong parentName="p">{`秘密はパテの焼き方`}</strong>{`にあるそうです。`}</p>
    <p>{`パテは、片面のみ強火で焼くことで肉汁が凝縮されたハンバーグになるとか。
肉汁あふれるハンバーグをランチで食べると、そのあとの仕事や用事も頑張れそうですよね。`}</p>
    <InstaImage postId="B9WtNXYDZAK" mdxType="InstaImage" />
    <h2>{`ランチのサイドメニュー`}</h2>
    <p>{`ランチにはハンバーグと一緒に、ボイルされた人参、野菜、ポテトがついています。ここにお味噌汁がついたセットになっているので、ハンバーグだけではなくボリューム感のあるランチメニューになっています。`}</p>
    <h3>{`ハンバーグ以外にはこんなメニューも！`}</h3>
    <InstaImage postId="B-j0--ggqm4" mdxType="InstaImage" />
    <p>{`先ほど紹介した和牛を使ってハンバーグではなく、和牛を生姜焼きにしたランチもリトルリマの人気メニューです！
生姜焼きと聞くと`}<strong parentName="p">{`豚肉`}</strong>{`のイメージが強いと思いますが、和牛の柔らかく脂が乗ったお肉に、香り高い生姜を使ってできる和牛の生姜焼き定食は、今までア体験したことがない最高の味わいに。`}</p>
    <ShopInfoBox shopId="brntfvi23akg00f31td0" mdxType="ShopInfoBox" />
    <h3>{`おわりに　`}</h3>
    <p>{`原宿で極上の神戸牛を使ったハンバーグランチが食べられる「リトルリマ」についてご紹介してきましたが、いかがでしたでしょうか。ハンバーグを食べたいとなった時には、原宿には中々お店がありません。原宿、青山、表参道で肉汁溢れるランチが食べたい時には、ハンバーグのリトルリマを検討してみてはいかがでしょうか。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;